import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row } from 'reactstrap';

class ConsumerSignIn extends Component {
  render() {
    return (
      <div className="page-preapproved narrow">
        <Container>
          <Row>
            <Col xs={12} className="text-center">
              <img src="/images/servicingusa-logo.svg" alt="ServicingUSA Sign In" className="mb-4" />
              <Row>
                <Col sm={{size: 8, offset: 2}} md={{size: 6, offset: 3}} lg={{size: 4, offset: 4}}>
                  <Card className="dark-shadow">
                    <CardHeader>Borrower Sign In</CardHeader>
                    <CardBody>
                      <FormGroup>
                        <Label for="userEmail">Email Address</Label>
                        <Input type="email" name="user-email" id="userEmail" />
                      </FormGroup>
                      <FormGroup>
                        <Label for="password">Password</Label>
                        <Input type="password" name="password" id="password" />
                      </FormGroup>
                      <Button color="primary" className="w-100">Sign In</Button>
                    </CardBody>
                  </Card>
                  <Row>
                    <Col xs={6}>
                      <Link to="/consumer/forgot-password">Forgot Password?</Link>
                    </Col>
                    <Col xs={6}>
                      <Link to="/consumer/create-account">Create Account</Link>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default ConsumerSignIn;
